import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  addItem: {
    marginTop: 8,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
}));

export default useStyles;
